import React, { useEffect } from 'react'
import Logo from "../../Assets/img/logo_n.png"
import Clock from "../../Assets/img/clock.svg"

const StartScreen = ({ handleStart }) => {
  useEffect(() => {
    document.title = "Cleer Tax Quiz";
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = "../../Assets/img/Favicon1.png"; // Path to your new favicon
    }

  }, [])

  useEffect(() => {
    // Add event listener for Enter key press
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleStart('true');
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleStart]); // Dependency to track `handleStart`

  return (
    <div class="layout_wrapper">
      <div class="layout_ordered_content">
        <div class="layout_order_Layout">
          <div class="welcome_screen_wrapper">
            <div class="layout_placement_wrapper">
              <div class="front_screen_wrapper">
                <div class="welcome_screen">
                  <div class="screen_content">
                    <div class="logo_img">
                      <img src={Logo} />
                    </div>
                    <div class="contant_div">
                      <h3>Want to know which Cleer package your company needs? Take this survey to get package recommendations!</h3>
                      <p>If you have any additional inquiries, contact us at <a href="mailto:hello@cleertax.com">hello@cleertax.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="welcome_screen_footer">
                <div class="welcome_screen_footer_wrapper">
                  <div class="time_div">
                    <img src={Clock} />Takes 45 sec
                  </div>
                  <div class="start_btn">
                    <button onClick={() => handleStart('true')} class="start_click">Start</button>
                    <span>Press <b> Enter ↵</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StartScreen